import React from "react";
import { Link } from "@inertiajs/inertia-react";
import { PhotoIcon, PlusIcon } from "@heroicons/react/24/outline";
import CustomerLayout from "../../../Layouts/CustomerLayout";

const statusStyles = {
  open: "bg-green-100 text-green-800",
  matched: "bg-blue-100 text-blue-800",
  closed: "bg-gray-100 text-gray-600",
  cancelled: "bg-red-100 text-red-700",
};

const statusLabel = {
  open: "Open",
  matched: "Matched",
  closed: "Closed",
  cancelled: "Cancelled",
};

const Index = ({ requests }) => (
  <CustomerLayout
    title="My Requests"
    subtitle="Track responses and manage the home visits you've requested from local tradespeople."
    primary_button={{
      name: "Request a home visit",
      link: "/domestic/requests/new",
      icon: PlusIcon,
    }}
  >
    <div>
      {requests.length === 0 ? (
        <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 bg-white py-16 text-center">
          <PhotoIcon className="h-10 w-10 text-gray-300" />
          <p className="mt-3 text-sm text-gray-500">
            You haven&apos;t made any requests yet.
          </p>
          <Link
            href="/domestic/requests/new"
            className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-orange-600 py-2.5 px-5 text-sm font-semibold text-white shadow-sm hover:bg-orange-700"
          >
            <PlusIcon className="h-4 w-4" />
            Request a home visit
          </Link>
        </div>
      ) : (
        <ul className="space-y-3">
          {requests.map((r) => {
            const thumb = r.images && r.images[0];
            return (
              <li key={r.id}>
                <Link
                  href={`/domestic/requests/${r.id}`}
                  className="flex gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:border-orange-300 hover:bg-orange-50/30 sm:p-5"
                >
                  <div className="hidden h-20 w-20 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-gray-100 sm:flex">
                    {thumb ? (
                      <img
                        src={thumb.thumb_url}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    ) : (
                      <PhotoIcon className="h-7 w-7 text-gray-300" />
                    )}
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-3">
                      <p className="truncate text-base font-semibold text-gray-900">
                        {r.trades.join(", ")}
                        {r.postcode_district_code && (
                          <span className="ml-2 text-sm font-normal text-gray-400">
                            {r.postcode_district_code}
                          </span>
                        )}
                      </p>
                      <span
                        className={`flex-shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium ${
                          statusStyles[r.status] || statusStyles.closed
                        }`}
                      >
                        {statusLabel[r.status] || "Closed"}
                      </span>
                    </div>
                    <p className="mt-1 truncate text-sm text-gray-600">
                      {r.description}
                    </p>
                    <div className="mt-2 flex items-center gap-3 text-xs text-gray-400">
                      <span>{r.created_at}</span>
                      {r.ideal_start_date && <span>Start {r.ideal_start_date}</span>}
                      <span className="ml-auto text-xs font-medium text-orange-700">
                        {r.response_count}{" "}
                        {r.response_count === 1 ? "response" : "responses"}
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  </CustomerLayout>
);

export default Index;
